import React from 'react';
import { action } from 'mobx';
import { injectIntl, FormattedMessage } from 'react-intl';
import { observer, inject } from 'mobx-react';
import {
  FormControl,
  ControlLabel,
  Row,
  Col,
  Panel,
  Button,
  Clearfix,
  ListGroup,
  ListGroupItem,
  Modal
} from 'react-bootstrap';
import Select from 'react-select-plus';
import 'react-select-plus/dist/react-select-plus.css';

@injectIntl
@inject('rootStore')
@observer
export default class Clone extends React.Component {
  constructor(props) {
    super(props);

    this.state = { bmc: null };
  }

  render() {
    const { rootStore, intl } = this.props;

    return (
      <div>
        <h3 style={{ textAlign: 'center' }}>
          {intl.formatMessage({ id: 'clone_header' })}
        </h3>
        <hr />
        <Col xs={12} sm={2}>
          <ControlLabel style={{ verticalAlign: 'text-top' }}>
            {intl.formatMessage({ id: 'clone_from' })}
          </ControlLabel>
        </Col>
        <Col xs={12} sm={8}>
          <Select
            onChange={this.handleSelectChange}
            value={this.state.bmc}
            placeholder=""
            options={this.renderSelectOptions()}
          />
        </Col>
        <Col xs={12} sm={2}>
          <Button
            bsStyle="primary"
            block
            onClick={this.handleCloneButton}
            disabled={!this.state.bmc || !this.state.bmc.value}
          >
            {intl.formatMessage({ id: 'clone' })}
          </Button>
        </Col>
        <br />
        <br />
      </div>
    );
  }

  @action
  handleCloneButton = () => {
    this.props.rootStore.cloneFromAnotherBmc(this.state.bmc.value);
  };

  handleSelectChange = value => {
    this.setState({ bmc: value });
  };

  renderSelectOptions = () => {
    const { rootStore } = this.props;

    let options = [];

    if (rootStore.bmcsFromVp) {
      const withoutCurrentBmc = rootStore.bmcsFromVp.filter(
        bmc => bmc.id !== rootStore.bmcId
      );

      options = withoutCurrentBmc.map(bmc => ({
        label: bmc.mvpName,
        value: bmc.id
      }));
    }

    return options;
  };
}
